import type * as lazyIndex from './lazyIndex';
import { popoutMailReadingPane } from 'owa-popout';
// Direct sub-path import — going through the package barrel pulls the full
// store index (adapters, services, selectors) into AppBoot. This file is
// eagerly evaluated at boot to register the orchestrator.
import { openDraftReplyFromBriefing } from 'owa-personal-os-store/lib/actions/openDraftReplyFromBriefingAction';
import {
    LazyModule,
    registerLazyOrchestrator,
    createLazyComponent,
    LazyAction,
    type LazyComponent,
} from 'owa-bundling';
import type { ProjectionReadingPaneProps } from './components/ProjectionReadingPane';

export const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule(
    () => import(/* webpackChunkName: "PopoutMailReadingPane"*/ './lazyIndex'),
    { name: 'PopoutMailReadingPane' }
);

// Register lazy orchestrators
registerLazyOrchestrator(
    popoutMailReadingPane,
    lazyModule,
    m => m.popoutMailReadingPaneOrchestrator
);
registerLazyOrchestrator(
    openDraftReplyFromBriefing,
    lazyModule,
    m => m.openDraftReplyFromBriefingOrchestrator
);

// Lazy components
export const ProjectionReadingPane: LazyComponent<ProjectionReadingPaneProps, unknown, void> =
    createLazyComponent(lazyModule, m => m.ProjectionReadingPane);
export const lazyPopoutMailReadingPaneUtil: LazyAction<
    typeof lazyIndex.popoutMailReadingPaneUtil,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.popoutMailReadingPaneUtil);
